import { useSelector } from 'react-redux';
import ReactDOMServer from 'react-dom/server';
import styled from 'styled-components';
import Translator from '../../../../../components/helpers/Translator';

export default function LastChange() {
  const isSidebarOpened = useSelector(
    (state) => state.auth?.settings?.preferences?.sidebar?.isOpened,
  );
  const lastChange = useSelector((state) => state.currentPage?.options?.lastChange);

  if (lastChange === undefined) return <></>;
  return (
    <>
      {isSidebarOpened ? (
        <>
          <Title>Último cambio</Title>
          <div
            className="mb-2"
            title={ReactDOMServer.renderToString(
              <Translator file="module-legalCompliance" name="last.change" />,
            )}
          >
            {lastChange?.dateStamp} - {lastChange?.username}
          </div>
        </>
      ) : null}
    </>
  );
}

const Title = styled.h6`
  font-size: 12px;
`;
